import { render, staticRenderFns } from "./RepairAdminList.vue?vue&type=template&id=f095076a&scoped=true"
import script from "./RepairAdminList.vue?vue&type=script&lang=js"
export * from "./RepairAdminList.vue?vue&type=script&lang=js"
import style0 from "./RepairAdminList.vue?vue&type=style&index=0&id=f095076a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f095076a",
  null
  
)

export default component.exports